import { Navigate } from "react-router-dom";
import useLangStore from "@/hooks/useLangStore";
import useAuthStore from "@/hooks/useAuthStore";
import useDashboardStore from "@/hooks/useDashboardStore";
import SelectStoreScreen from "@/UI/screens/SelectStoreScreen";

export default function SelectStoreRoute() {
    const { lang } = useLangStore();
    const { token } = useAuthStore();
    const { storeId } = useDashboardStore();
    if (!lang) return <Navigate to="/choose-lang" replace />;
    if (!token) return <Navigate to="/login" replace />;
    if (storeId) return <Navigate to="/" replace />;
    return <SelectStoreScreen />;
}
